import { useRuntimeStore } from '@/store/runtime'

export default function user_id(identity) {
    // username or pk of the user
    const runtimeStore = useRuntimeStore()

    if (!runtimeStore.session.user) return false

    if (runtimeStore.session.user.pk === identity?.pk) {
        return true
    }
    // if (runtimeStore.session.user.username === identity?.username) {
    //     return true
    // }

    return false
}
